import React from 'react';
import PropTypes from 'prop-types';
import CalendarListItem from './CalendarListItem/CalendarListItem';

const CalendarList = ({
  events,
  endAccessor,
  startAccessor,
  titleAccessor,
  url,
  onClose,
}) => {
  return (
    <div className="calendar-list-container">
      {events.map((singleEvent, index) => {
        return (
          <CalendarListItem
            key={`${singleEvent[titleAccessor]}-${index}`}
            title_sk={singleEvent[titleAccessor]}
            from={singleEvent[startAccessor]}
            to={singleEvent[endAccessor]}
            url={singleEvent[url]}
            onClose={onClose}
          />
        );
      })}
    </div>
  );
};

CalendarList.propTypes = {
  events: PropTypes.array,
  endAccessor: PropTypes.string, // this is here because calendar returns different array
  startAccessor: PropTypes.string,
  titleAccessor: PropTypes.string,
  url: PropTypes.string,
  onClose: PropTypes.func,
};

export default CalendarList;
